// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bbhhusjprzalcwvkgvsa.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJiaGh1c2pwcnphbGN3dmtndnNhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMzNTcxMDAsImV4cCI6MjA1ODkzMzEwMH0.1R4QLc3B4eqJPnGM4WWjsrP6Mid3bzXEqPYtWrlnS10";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);